export const VALUEMAPPING_ROUTES = <const>{
	list: '',
	create: 'valuemapping/profile/create',
	edit: 'valuemapping/profile/:profileId',
};

export const SENSOR_GROUP_ROUTES = <const>{
	list: '',
	create: 'sensor-group/create',
	edit: 'sensor-group/:sensorGroupId',
};

export const LIFT_STATION_ROUTES = <const>{
	list: '',
	create: 'lift-stations/create',
	edit: 'lift-station/:liftStationId',
};

export enum MAIN_ROUTES {
	Admin = '/admin',
	GeneralSettings = '/admin/general-settings',
	UserManagement = '/admin/user-management',
	Implementation = '/admin/implementation',
	SystemConnections = '/admin/system-connections',
	SensorConfiguration = '/admin/sensor-configuration',
	ValueMapping = '/admin/value-mapping',
	Billing = '/admin/billing',
	SensorGroups = '/admin/sensor-groups',
	Stations = '/admin/stations',
}
